import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#fff",
    minHeight: "calc(100vh - 300px)",
    borderRight: "1px solid #e6e6e6",
    paddingTop: 2,
    overflowY: "scroll",
  },
  groupmenu: {
    paddingLeft: 2,
    paddingRight: 2,
    paddingBottom: 1,
    fontSize: 12,
    fontWeight: 700,
    color: "#b5a79a",
    letterSpacing: "0.08em",
  },

  menuItem: {
    paddingLeft: 12,
    paddingRight: 2,
    paddingTop: 1.2,
    paddingBottom: 1.2,
    color: "#333",
    "&.active": {
      backgroundColor: "#fdf1e5",
      color: "#ef7d00",
      borderLeft: "3px solid #ef7d00",
    },
  },

  completeBadge: {
    borderRight: "3px solid green", 
    padding: "15px"
  },

  incompleteBadge: {
    borderRight: "3px solid red", 
    padding: "15px"
  },

}));
